<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><span class="textStyle4">The Characters in the Tale</span></p>
<p class="hang"><span class="textStyle5">Chief Detective-Inspector Roderick Alleyn,</span> <span class="textStyle6">C.I.D.</span></p>
<p class="hang"><span class="textStyle5">Miss Van Maes,</span> <span class="textStyle7">the success of the ship.</span></p>
<p class="hang"><span class="textStyle5">Agatha Troy,</span> <span class="textStyle7">R.A., of Tatter’s End House, Bossicote, Bucks. Painter.</span></p>
<p class="hang"><span class="textStyle5">Katti Bostock,</span> <span class="textStyle7">well-known painter of plumbers and black musicians.</span></p>
<p class="hang"><span class="textStyle5">Nigel Bathgate,</span> <span class="textStyle7">journalist.</span></p>
<p class="hang"><span class="textStyle5">Lady Alleyn, of Danes Lodge, Bossicote, Bucks;</span> <span class="textStyle7">mother of Chief Detective-Inspector Alleyn.</span></p>
<p class="hang"><span class="textStyle5">Cedric Malmsley,</span> <span class="textStyle7">a student with a beard.</span></p>
<p class="hang"><span class="textStyle5">Garcia,</span> <span class="textStyle7">a sculptor.</span></p>
<p class="hang"><span class="textStyle5">Sonia Gluck,</span> <span class="textStyle7">a model.</span></p>
<p class="hang"><span class="textStyle5">Francis Ormerin,</span> <span class="textStyle7">a student from Paris.</span></p>
<p class="hang"><span class="textStyle5">Phillida Lee,</span> <span class="textStyle7">a student from the Slade.</span></p>
<p class="hang"><span class="textStyle5">Watt Hatchett,</span> <span class="textStyle7">a student from Australia.</span></p>
<p class="hang"><span class="textStyle5">The Hon. Basil Pilgrim,</span> <span class="textStyle7">a student from the nobility.</span></p>
<p class="hang"><span class="textStyle5">Valmai Seacliff,</span> <span class="textStyle7">a student with sex-appeal.</span></p>
<p class="hang"><span class="textStyle5">Superintendent Blackman,</span> <span class="textStyle7">of the Buckingham Constabulary Force.</span></p>
<p class="hang"><span class="textStyle5">Detective-Inspector Fox,</span> <span class="textStyle7">C.I.D.</span></p>
<p class="hang"><span class="textStyle5">Detective-Sergeant Bailey,</span> <span class="textStyle7">C.I.D., a fingerprint expert.</span></p>
<p class="hang"><span class="textStyle5">Detective-Sergeant Thompson,</span> <span class="textStyle7">C.I.D., a photographic expert.</span></p>
<p class="hang"><span class="textStyle5">Dr. Ampthill,</span> <span class="textStyle7">police surgeon at Bossicote, Bucks.</span></p>
<p class="hang"><span class="textStyle5">P.C. Sligo,</span> <span class="textStyle7">of Bossicote Police force.</span></p>
<p class="hang"><span class="textStyle5">A Charlady</span></p>
<p class="hang"><span class="textStyle5">Bobbie O’Dawne,</span> <span class="textStyle7">a lady of the Ensemble.</span></p>
<p class="hang"><span class="textStyle5">An Estate Agent</span></p>
<p class="hang"><span class="textStyle5">Ted McCully,</span> <span class="textStyle7">foreman at a car depot.</span></p>
<p class="hang"><span class="textStyle5">Dr. Curtis,</span> <span class="textStyle7">police surgeon, C.I.D.</span></p>
<p class="hang"><span class="textStyle5">Captain Pascoe, of Boxover.</span></p>
<p class="hang"><span class="textStyle5">His Servant</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontMatter01.vue?23c48352